import React from 'react';
import { Phone } from 'lucide-react';

export const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/5527996482098"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 bg-cobalt hover:bg-abyssal text-white p-4 rounded-full shadow-lg shadow-cobalt/20 transition-colors"
      aria-label="Contato via WhatsApp"
    >
      <Phone className="h-6 w-6" />
    </a>
  );
};
